import { useIsLoggedIn } from '@/hooks/react-query/user/use-user'
import { mapFocProfileResponseToKolProfile } from '@/lib/helpers/kol-profile.helper'
import { __cFocCampaignService } from '@/services/client/__c.foc-campaign.service'
import { useQuery } from '@tanstack/react-query'

export const useFocProfileQuery = () => {
  const isLoggedIn = useIsLoggedIn()

  return useQuery({
    queryKey: ['foc-profile-me'],
    queryFn: () => __cFocCampaignService.getMyProfile(),
    enabled: isLoggedIn,
    select: (data) => (data ? mapFocProfileResponseToKolProfile(data) : null),
  })
}
